<style scoped>
.log-toolbar {
  margin-bottom: 15px;
}

.log-toolbar .form-control {
  display: inline-block;
  width: auto;
}

.log-viewer {
  min-height: 520px;
  max-height: 70vh;
  overflow: auto;
  white-space: pre;
  word-break: normal;
  background: #0f1720;
  color: #d8e1ea;
  border-radius: 4px;
  padding: 15px;
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  text-align: left;
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
}
</style>

<template>
  <div class="jumbotron bg-transparent text-center margin-none">
    <h1>运行日志</h1>
    <div class="item col-md-12 col-xs-12">
      <div class="panel panel-default">
        <div class="panel-body">
          <div class="row log-toolbar">
            <div class="col-sm-4 text-left">
              <strong>当前写入：</strong>logs/{{ currentFile }}
            </div>
            <div class="col-sm-4 text-left">
              <strong>查看文件：</strong>
              <select class="form-control input-sm" v-model="selectedFile" @change="changeFile">
                <option v-for="file in files" :key="file" :value="file">{{ file }}</option>
              </select>
            </div>
            <div class="col-sm-4 text-right">
              <button @click="togglePause" class="btn btn-default btn-sm">
                {{ paused ? '恢复自动刷新' : '暂停自动刷新' }}
              </button>
            </div>
          </div>
          <pre ref="viewer" class="log-viewer">{{ content || '暂无日志内容' }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'log-page',
  data() {
    return {
      content: '',
      currentFile: '',
      selectedFile: '',
      files: [],
      paused: false,
      loading: false,
      timer: null
    }
  },
  methods: {
    loadUrl: function() {
      var url = '/logs'
      if (this.selectedFile) {
        url += '?file=' + encodeURIComponent(this.selectedFile)
      }
      return url
    },
    loadLogs: function() {
      this.loading = true
      this.$http.get(this.loadUrl()).then(function(res) {
        this.loading = false
        if (res.data.error) {
          alert(res.data.message || '加载日志失败')
          return
        }
        var data = res.data.data || {}
        this.content = data.content || ''
        this.currentFile = data.currentFile || this.currentFile
        this.selectedFile = data.selectedFile || this.selectedFile || this.currentFile
        this.files = data.files || this.files
        this.$nextTick(function() {
          if (!this.paused && this.selectedFile === this.currentFile && this.$refs.viewer) {
            this.$refs.viewer.scrollTop = this.$refs.viewer.scrollHeight
          }
        })
        this.syncTimer()
      }, function() {
        this.loading = false
        if (this.$root.auth && this.$root.auth.loggingOut) {
          return
        }
        console.log('运行日志加载失败')
      })
    },
    syncTimer: function() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      if (this.paused) {
        return
      }
      if (this.selectedFile && this.currentFile && this.selectedFile !== this.currentFile) {
        return
      }
      this.timer = setInterval(function() {
        this.loadLogs()
      }.bind(this), 5000)
    },
    togglePause: function() {
      this.paused = !this.paused
      this.syncTimer()
    },
    changeFile: function() {
      this.loadLogs()
    }
  },
  created() {
    this.loadLogs()
  },
  beforeDestroy() {
    if (!this.timer) {
      return
    }
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>



// WEBPACK FOOTER //
// Log.vue?99b6bcbe